import * as React from 'react'
import Content from '../../../pages/shared/content'

export enum destinationEnum {
  allOfEurope = 1,
  outsideEurope,
  northEurope,
  eastEurope,
  southEurope,
  westEurope,
}

export interface DaysAndDestination {
  dest: destinationEnum
  days: number
}

export function getPlaceholder(value: destinationEnum) {
  switch (+value) {
    case destinationEnum.allOfEurope: {
      return 'All of Europe'
    }
    case destinationEnum.outsideEurope: {
      return 'Outside Europe'
    }
    case destinationEnum.northEurope: {
      return 'North Europe'
    }
    case destinationEnum.eastEurope: {
      return 'East Europe'
    }
    case destinationEnum.southEurope: {
      return 'South Europe'
    }
    case destinationEnum.westEurope: {
      return 'West Europe'
    }
    default: {
      return 'Not in enum'
    }
  }
}

export function getValueFromDestionation(destination: destinationEnum) {
  switch (destination) {
    case destinationEnum.allOfEurope:
      return 'all_of_europe'
    case destinationEnum.outsideEurope:
      return 'outside_europe'
    case destinationEnum.northEurope:
      return 'northern_europe'
    case destinationEnum.eastEurope:
      return 'eastern_europe'
    case destinationEnum.southEurope:
      return 'southern_europe'
    case destinationEnum.westEurope:
      return 'western_europe'
  }
}

export function getDestinationFromAPI(destination?: string) {
  switch (destination) {
    case 'all_of_europe':
      return destinationEnum.allOfEurope
    case 'outside_europe':
    default:
      return destinationEnum.outsideEurope
    case 'northern_europe':
      return destinationEnum.northEurope
    case 'eastern_europe':
      return destinationEnum.eastEurope
    case 'southern_europe':
      return destinationEnum.southEurope
    case 'western_europe':
      return destinationEnum.westEurope
  }
}

export function getDestination(value: destinationEnum) {
  return (
    <Content addNode contentKey={`destination-${destinationEnum[value]}`}>
      {getPlaceholder(value)}
    </Content>
  )
}

export function getDestinationFromValue(value: DaysAndDestination) {
  return getDestination(value.dest)
}
